import { pubsub } from '@services';

class SearchInput extends HTMLElement {
  #searchInput = this.querySelector('input[type="search"]');

  connectedCallback() {
    // Get elements

    // Handle search input
    this.#searchInput.addEventListener('input', () => {
      pubsub.publish('search:input', {
        id: this.id,
        data: { value: this.#searchInput.value },
      });

      this.#toggleClearButton();
    });

    // Handle search clear
    this.addEventListener('click', ({ target }) => {
      if (!target.closest('[data-search-clear]')) return;
      this.clearSearchInput();
    });
  }

  /**
   * Clear the search input
   */
  clearSearchInput() {
    this.#searchInput.value = '';
    pubsub.publish('search:clear', {
      id: this.id,
      data: { value: '' },
    });
    this.#toggleClearButton();
    this.#searchInput.focus();
  }

  /**
   * Toggle the clear button
   */
  #toggleClearButton() {
    this.querySelector('[data-search-clear]').ariaHidden = this.#searchInput.value.length === 0;
  }
}

customElements.define('search-input', SearchInput);
